import React from "react";

import { Fab, Container, Stack, Tooltip, Typography } from "@mui/material";
import { Plus as CreateIcon } from "mdi-material-ui";

import Layout from "components/common/Layout";
import SearchInput from "components/common/SearchInput";

import CreateSignatureMouthpiece from "components/signatureMouthpiece/CreateSignatureMouthpiece";
import SignatureMouthpiecesList from "components/signatureMouthpiece/SignatureMouthpiecesList";

export default function SignatureMouthpiecesPage() {
  const [search, setSearch] = React.useState("");

  return (
    <Container fixed>
      <Layout.Toolbar fixed>
        <Stack spacing={2} direction="row" alignItems="center">
          <CreateSignatureMouthpiece>
            {({ open }) => (
              <Tooltip placement="top" title="Créer un bec signature">
                <Fab onClick={open} size="small" color="primary">
                  <CreateIcon />
                </Fab>
              </Tooltip>
            )}
          </CreateSignatureMouthpiece>

          <Typography variant="h4" color="primary" sx={{ flexGrow: 1 }}>
            Becs signature
          </Typography>

          <SearchInput onChange={setSearch} />
        </Stack>
      </Layout.Toolbar>

      <SignatureMouthpiecesList search={search} />
    </Container>
  );
}
